export default "__VITE_ASSET__fab1e9ea__"